import TermLink, { TermLinkProps } from '@feature/TermLink'
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { concatTerms } from 'helpers'
import React, { ReactChild } from 'react'
import { colors } from 'theme/themePalette'
import { Product, TermBase } from 'types'

export type ProductDataTableProps = {
  product?: Product
}

const ProductDataTable = ({ product, ...props }: ProductDataTableProps) => {
  if (!product) return <></>

  const linkProps: Partial<TermLinkProps> = {
    underline: 'always',
    color: 'inherit',
  }

  const termsToLinks = (terms: TermBase[], join?: ReactChild) => {
    if (!terms.length) return null
    return terms.reduce((results, item, i) => {
      if (i > 0) results = results.concat(join ?? <>{` `}</>)
      results = results.concat(<TermLink key={i} term={item} {...linkProps} />)
      return results
    }, [] as ReactChild[])
  }

  const brand = product.brands.length ? product.brands[0] : undefined
  const productCategory = product.productCategories.length ? product.productCategories[0] : undefined

  const tableData = {
    brand: ['Brand Name', brand ? <TermLink term={brand} {...linkProps} /> : null],
    packSize: ['Product Size', product.packSize],
    // subbrands: ['Sub-brand', concatTerms(product.subbrands)],
    productCategories: ['Product Category', productCategory ? <TermLink term={productCategory} {...linkProps} /> : null],
    organics: ['Organic', concatTerms(product.organics)],
    // producingCountries: ['Producer Country', termsToLinks(product.producingCountries, ', ')],
    countries: ['Available in', concatTerms(product.countries)],
  }
  return (
    <Table>
      <TableHead sx={{ bgcolor: 'secondary.main' }}>
        <TableRow>
          <TableCell>
            <Typography variant="bold">{'Product Info'}</Typography>
          </TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.values(tableData).map(([key, value], i) => {
          return value ? (
            <TableRow key={i} sx={{ bgcolor: colors.offWhite }}>
              <TableCell sx={{ borderBottom: '2px solid white' }}>
                <Typography variant="bold">{key}</Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: '2px solid white' }}>
                <Typography>{value}</Typography>
              </TableCell>
            </TableRow>
          ) : null
        })}
      </TableBody>
    </Table>
  )
}

export default ProductDataTable
